<template>
  <div
    v-if="merchandisingBlock"
    class="mb-6 col-span-2 bg-red-200 relative overflow-hidden group"
    style="min-height: 350px;"
  >
    <div
      v-if="merchandisingBlock.cover"
      class="absolute top-0 left-0 right-0 bottom-0 transform scale-100 group-hover:scale-105 transition-transform duration-700 z-0"
      :style="{backgroundImage: `url(${merchandisingBlock.cover}?w=800&format=webp)`, backgroundSize: 'cover', backgroundPosition: 'center'}"
    >
    </div>
    <div class="absolute top-0 left-0 right-0 bottom-0 flex justify-end flex-col">
      <div class="p-4 flex justify-end">
        <SkyBtn arrow-right class="bg-sky_blue text-white" dark :href="merchandisingBlock.lien">{{ merchandisingBlock.titre }}</SkyBtn>
      </div>
    </div>
  </div>
</template>

<script>
import SkyBtn from '../general/SkyBtn'

export default {
  components: {
    SkyBtn
  },
  props: {
    merchandisingBlock: {
      type: Object,
      required: true
    }
  }
}
</script>
